'use client'

import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  HoVBrandnewSectionModel,
  HoVLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { HoVBrandnewSectionCard } from './HoVBradnewSectionCard'

type Props = {
  data: HoVBrandnewSectionModel
}

const HoVBrandnewSection = ({ data: { title, cards, ctaUrl, ctaText } }: Props) => {
  const { track } = useTracking()
  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.BrandnewCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section className="hov__brandnew-section">
      <h2 className="hov__brandnew-section-title">{title}</h2>
      <div className="hov__brandnew-section-cards">
        {cards.map((props, index) => (
          <HoVBrandnewSectionCard {...props} key={index} />
        ))}
      </div>
      <div className="hov__brandnew-section-cta-container">
        <a
          role="button"
          href={ctaUrl}
          className="hov__brandnew-section-cta"
          data-testid="hov-brandnew-cta"
          onClick={handleOnCtaClick}
        >
          {ctaText}
        </a>
      </div>
    </section>
  )
}

export default HoVBrandnewSection
